import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import StyleTwoClassTabsTables from './StyleTwoClassTabsTables'

export class StyleTwoClassTabs extends Component {
  static propTypes = {
    styleTwo: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };
  state = {
    defaultIndex: 1,
    list: []
  }
  componentWillMount() {
    this.setState({ list: this.props.list });
  }
  componentWillReceiveProps(nextProps) {
    nextProps.list.map(item => {
      if (item.active) {
        this.setState({ defaultIndex: item.id });
      }
    })
    this.setState({ list: nextProps.list });
  }
  toggleTabs(id) {
    let { list } = this.state;
    list.map(item => {
      if (item.id === id) {
        item.active = true;
      } else {
        item.active = false;
      }
    })
    this.setState({ defaultIndex: id, list })
  }

  render() {
    let { defaultIndex, list } = this.state;
    let { onMeiQiaCustomer, listId, colorData } = this.props;

    return (
      <div className="style-two-style-two-class-tabs">
        <div className='class_tabs flex_row' style={{ borderBottom: `2px solid ${colorData.color}` }}>
          {list && list.map(item => <div className={item.active ? 'class_tabs_item active flex_row' : 'class_tabs_item flex_row'} style={{ backgroundImage: item.active ? colorData.backgroundImage : '' }} key={item.id} onClick={this.toggleTabs.bind(this, item.id)}>{item.title}</div>)}
        </div>
        <div className='class_content_box'>
          <StyleTwoClassTabsTables Data={list[defaultIndex - 1]} listId={listId} onMeiQiaCustomer={onMeiQiaCustomer} colorData={colorData} />
        </div>
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    styleTwo: state.styleTwo,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StyleTwoClassTabs);



// WEBPACK FOOTER //
// ./src/features/style-two/StyleTwoClassTabs.js